import React, {FC} from 'react';

import {KeyboardActionsEnum} from '../../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {VisuallyHidden} from '../../../../../libs/shared/ui/src/components/visuallyHidden/visuallyHidden';
import {TooltipLabelWithShortcut} from '../../../common/tooltips/tooltipLabelWithShortcut';
import {CommentComposerIcon} from './commentComposerIcon';

/*
 * Props.
 */

export interface CommentComposerExpandToggleProps {
  isExpanded: boolean;
  onClick: Handler;
  isDisabled?: boolean;
}

/*
 * Component.
 */

export const CommentComposerExpandToggle: FC<CommentComposerExpandToggleProps> = (props) => (
  <ChromelessButton
    shouldPreventMouseDown
    isActive={props.isExpanded}
    isDisabled={props.isDisabled}
    onClick={props.onClick}
  >
    <CommentComposerIcon
      iconName={props.isExpanded ? 'collapseSmall' : 'expandSmall'}
      isDisabled={props.isDisabled}
      renderTooltip={() => !props.isDisabled && renderTooltip(props.isExpanded)}
    />
    <VisuallyHidden>
      {props.isExpanded ? (
        <Trans id="commentcomposer-collapse-a11y">Collapse comment composer</Trans>
      ) : (
        <Trans id="commentcomposer-expand-a11y">Expand comment composer</Trans>
      )}
    </VisuallyHidden>
  </ChromelessButton>
);

function renderTooltip(isExpanded: boolean) {
  const label = isExpanded ? (
    <Trans id="commentcomposer-collapse">Collapse</Trans>
  ) : (
    <Trans id="commentcomposer-expand">Expand</Trans>
  );

  return (
    <TooltipLabelWithShortcut
      label={label}
      keyboardAction={KeyboardActionsEnum.TOGGLE_EXPANDED_COMMENT_COMPOSER}
    />
  );
}
